/**
 * Define static data for various PDP Tables
 */

const WomensDressesAndTopsHeader = [
  [
    [
      { value: 'Size', colspan: 2 },
      { value: 'Bust' },
      { value: 'Waist' },
      { value: 'Hip' },
    ],
  ],
];

const WomensBottomsHeader = [
  [[{ value: 'Size', colspan: 2 }, { value: 'Waist' }, { value: 'Hip' }]],
];

export const WomensRegularDressesAndTops = {
  header: WomensDressesAndTopsHeader,
  body: [
    [
      [
        { value: 'XS', rowspan: 2 },
        { value: '0' },
        { value: '32″' },
        { value: '24″' },
        { value: '34″' },
      ],
      [{ value: '2' }, { value: '33″' }, { value: '26″' }, { value: '36″' }],
    ],
    [
      [
        { value: 'S', rowspan: 2 },
        { value: '4' },
        { value: '34½″' },
        { value: '27½″' },
        { value: '37½″' },
      ],
      [{ value: '6' }, { value: '35½″' }, { value: '28½″' }, { value: '38½″' }],
    ],
    [
      [
        { value: 'M', rowspan: 2 },
        { value: '8' },
        { value: '36½″' },
        { value: '29½″' },
        { value: '39½″' },
      ],
      [{ value: '10' }, { value: '38″' }, { value: '31″' }, { value: '41″' }],
    ],
    [
      [
        { value: 'L' },
        { value: '12' },
        { value: '39½″' },
        { value: '32½″' },
        { value: '42½″' },
      ],
    ],
    [
      [
        { value: 'XL' },
        { value: '14' },
        { value: '41¼″' },
        { value: '34¼″' },
        { value: '44¼″' },
      ],
    ],
    [
      [
        { value: 'XXL' },
        { value: '16' },
        { value: '43″' },
        { value: '36″' },
        { value: '46″' },
      ],
    ],
  ],
};

export const WomensRegularBottoms = {
  header: WomensBottomsHeader,
  body: [
    [
      [
        { value: 'XS', rowspan: 2 },
        { value: '0' },
        { value: '24″' },
        { value: '34″' },
      ],
      [{ value: '2' }, { value: '26″' }, { value: '36″' }],
    ],
    [
      [
        { value: 'S', rowspan: 2 },
        { value: '4' },
        { value: '27½″' },
        { value: '37½″' },
      ],
      [{ value: '6' }, { value: '28½″' }, { value: '38½″' }],
    ],
    [
      [
        { value: 'M', rowspan: 2 },
        { value: '8' },
        { value: '29½″' },
        { value: '39½″' },
      ],
      [{ value: '10' }, { value: '31″' }, { value: '41″' }],
    ],
    [[{ value: 'L' }, { value: '12' }, { value: '32½″' }, { value: '42½″' }]],
    [[{ value: 'XL' }, { value: '14' }, { value: '34¼″' }, { value: '44¼″' }]],
    [[{ value: 'XXL' }, { value: '16' }, { value: '36″' }, { value: '46″' }]],
  ],
};

export const WomensPlusDressesAndTops = {
  header: WomensDressesAndTopsHeader,
  body: [
    [
      [
        { value: '1X', rowspan: 2 },
        { value: '14W' },
        { value: '42½″' },
        { value: '37″' },
        { value: '46½″' },
      ],
      [{ value: '16W' }, { value: '44″' }, { value: '38½″' }, { value: '48″' }],
    ],
    [
      [
        { value: '2X', rowspan: 2 },
        { value: '18W' },
        { value: '45½″' },
        { value: '40″' },
        { value: '49½″' },
      ],
      [{ value: '20W' }, { value: '47″' }, { value: '41½″' }, { value: '51″' }],
    ],
    [
      [
        { value: '3X', rowspan: 2 },
        { value: '22W' },
        { value: '49¼″' },
        { value: '43¾″' },
        { value: '53¼″' },
      ],
      [
        { value: '24W' },
        { value: '51½″' },
        { value: '46″' },
        { value: '55½″' },
      ],
    ],
  ],
};

export const WomensPlusBottoms = {
  header: WomensBottomsHeader,
  body: [
    [
      [
        { value: '1X', rowspan: 2 },
        { value: '14W' },
        { value: '37″' },
        { value: '46½″' },
      ],
      [{ value: '16W' }, { value: '38½″' }, { value: '48″' }],
    ],
    [
      [
        { value: '2X', rowspan: 2 },
        { value: '18W' },
        { value: '40″' },
        { value: '49½″' },
      ],
      [{ value: '20W' }, { value: '41½″' }, { value: '51″' }],
    ],
    [
      [
        { value: '3X', rowspan: 2 },
        { value: '22W' },
        { value: '44″' },
        { value: '53½″' },
      ],
      [{ value: '24W' }, { value: '46½″' }, { value: '56″' }],
    ],
  ],
};

export const WomensPetiteDressesAndTops = {
  header: WomensDressesAndTopsHeader,
  body: [
    [
      [
        { value: 'XSP', rowspan: 2 },
        { value: '0P' },
        { value: '32″' },
        { value: '24″' },
        { value: '34″' },
      ],
      [{ value: '2P' }, { value: '33″' }, { value: '26″' }, { value: '36″' }],
    ],
    [
      [
        { value: 'SP', rowspan: 2 },
        { value: '4P' },
        { value: '34½″' },
        { value: '27½″' },
        { value: '37½″' },
      ],
      [
        { value: '6P' },
        { value: '35½″' },
        { value: '28½″' },
        { value: '38½″' },
      ],
    ],
    [
      [
        { value: 'MP', rowspan: 2 },
        { value: '8P' },
        { value: '36½″' },
        { value: '29½″' },
        { value: '39½″' },
      ],
      [{ value: '10P' }, { value: '38″' }, { value: '31″' }, { value: '41″' }],
    ],
    [
      [
        { value: 'LP' },
        { value: '12P' },
        { value: '39½″' },
        { value: '32½″' },
        { value: '42½″' },
      ],
    ],
    [
      [
        { value: 'XLP' },
        { value: '14P' },
        { value: '41¼″' },
        { value: '34¼″' },
        { value: '44¼″' },
      ],
    ],
    [
      [
        { value: 'XXLP' },
        { value: '16P' },
        { value: '43″' },
        { value: '36″' },
        { value: '46″' },
      ],
    ],
  ],
};

export const WomensPetiteBottoms = {
  header: WomensBottomsHeader,
  body: [
    [
      [
        { value: 'XSP', rowspan: 2 },
        { value: '0P' },
        { value: '24″' },
        { value: '34″' },
      ],
      [{ value: '2P' }, { value: '26″' }, { value: '36″' }],
    ],
    [
      [
        { value: 'SP', rowspan: 2 },
        { value: '4P' },
        { value: '27½″' },
        { value: '37½″' },
      ],
      [{ value: '6P' }, { value: '28½″' }, { value: '38½″' }],
    ],
    [
      [
        { value: 'MP', rowspan: 2 },
        { value: '8P' },
        { value: '29½″' },
        { value: '39½″' },
      ],
      [{ value: '10P' }, { value: '31″' }, { value: '41″' }],
    ],
    [[{ value: 'LP' }, { value: '12P' }, { value: '32½″' }, { value: '42½″' }]],
    [
      [
        { value: 'XLP' },
        { value: '14P' },
        { value: '34¼″' },
        { value: '44¼″' },
      ],
    ],
    [[{ value: 'XXLP' }, { value: '16P' }, { value: '36″' }, { value: '46″' }]],
  ],
};

const MensTopsHeader = [
  [
    [
      { value: 'Size' },
      { value: 'Chest' },
      { value: 'Neck' },
      { value: 'Arm length' },
    ],
  ],
];

const MensBottomsHeader = [[[{ value: 'Size' }, { value: 'Waist' }]]];

const MensBottomsBody = [
  [[{ value: 'XS' }, { value: '28″–29″' }]],
  [[{ value: 'S' }, { value: '30″–31″' }]],
  [[{ value: 'M' }, { value: '32″–34″' }]],
  [[{ value: 'L' }, { value: '34″–36″' }]],
  [[{ value: 'XL' }, { value: '38″–40″' }]],
  [[{ value: 'XXL' }, { value: '42″–44″' }]],
  [[{ value: '3XL' }, { value: '46″–48″' }]],
];

const MensBeltBody = [
  [[{ value: '32' }, { value: 'up to 30″' }]],
  [[{ value: '34' }, { value: '31″–33″' }]],
  [[{ value: '36' }, { value: '34″–35″' }]],
  [[{ value: '38' }, { value: '36″–37″' }]],
  [[{ value: '40' }, { value: '38″–39″' }]],
  [[{ value: '42' }, { value: '40″–41″' }]],
  [[{ value: '44' }, { value: '42″–43″' }]],
  [[{ value: '46' }, { value: '44″–45″' }]],
  [[{ value: '48' }, { value: '44″–45″' }]],
  [[{ value: '50' }, { value: '48″ and up' }]],
];

const MensBeltsHeader = [[[{ value: 'Belt size' }, { value: 'Waist' }]]];

export const MensStandardTops = {
  header: MensTopsHeader,
  body: [
    [
      [
        { value: 'XS' },
        { value: '34″–35″' },
        { value: '14.5″' },
        { value: '30.5″' },
      ],
    ],
    [
      [
        { value: 'S' },
        { value: '36″–37″' },
        { value: '15″' },
        { value: '31.75″' },
      ],
    ],
    [
      [
        { value: 'M' },
        { value: '38″–40″' },
        { value: '15.5″' },
        { value: '33″' },
      ],
    ],
    [
      [
        { value: 'L' },
        { value: '41″–43″' },
        { value: '16″–16.5″' },
        { value: '34″' },
      ],
    ],
    [
      [
        { value: 'XL' },
        { value: '44″–46″' },
        { value: '17″–17.5″' },
        { value: '35″' },
      ],
    ],
    [
      [
        { value: 'XXL' },
        { value: '47″–51″' },
        { value: '18″–18.5″' },
        { value: '35.75″' },
      ],
    ],
    [
      [
        { value: '3XL' },
        { value: '52″–56″' },
        { value: '19″–19.5″' },
        { value: '36.5″' },
      ],
    ],
  ],
};

export const MensStandardBottoms = {
  header: MensBottomsHeader,
  body: MensBottomsBody,
};

export const MensStandardBelts = {
  header: MensBeltsHeader,
  body: MensBeltBody,
};

export const MensShortTops = {
  header: MensTopsHeader,
  body: [
    [
      [
        { value: 'XS-SH' },
        { value: '34″–35″' },
        { value: '14.5″' },
        { value: '29.5″' },
      ],
    ],
    [
      [
        { value: 'S-SH' },
        { value: '36″–37″' },
        { value: '15″' },
        { value: '30.75″' },
      ],
    ],
    [
      [
        { value: 'M-SH' },
        { value: '38″–40″' },
        { value: '15.5″' },
        { value: '32″' },
      ],
    ],
    [
      [
        { value: 'L-SH' },
        { value: '41″–43″' },
        { value: '16″–16.5″' },
        { value: '33″' },
      ],
    ],
    [
      [
        { value: 'XL-SH' },
        { value: '44″–46″' },
        { value: '17″–17.5″' },
        { value: '34″' },
      ],
    ],
    [
      [
        { value: 'XXL-SH' },
        { value: '47″–51″' },
        { value: '18″–18.5″' },
        { value: '34.75″' },
      ],
    ],
    [
      [
        { value: '3XL-SH' },
        { value: '52″–56″' },
        { value: '19″–19.5″' },
        { value: '35.5″' },
      ],
    ],
  ],
};

export const MensShortBottoms = {
  header: MensBottomsHeader,
  body: MensBottomsBody,
};

export const MensShortBelts = {
  header: MensBeltsHeader,
  body: MensBeltBody,
};

export const MensTallTops = {
  header: MensTopsHeader,
  body: [
    [
      [
        { value: 'XS-TA' },
        { value: '34″–35″' },
        { value: '14.5″' },
        { value: '31.5″' },
      ],
    ],
    [
      [
        { value: 'S-TA' },
        { value: '36″–37″' },
        { value: '15″' },
        { value: '32.75″' },
      ],
    ],
    [
      [
        { value: 'M-TA' },
        { value: '38″–40″' },
        { value: '15.5″' },
        { value: '34″' },
      ],
    ],
    [
      [
        { value: 'L-TA' },
        { value: '41″–43″' },
        { value: '16″–16.5″' },
        { value: '35″' },
      ],
    ],
    [
      [
        { value: 'XL-TA' },
        { value: '44″–46″' },
        { value: '17″–17.5″' },
        { value: '36″' },
      ],
    ],
    [
      [
        { value: 'XXL-TA' },
        { value: '47″–51″' },
        { value: '18″–18.5″' },
        { value: '36.75″' },
      ],
    ],
    [
      [
        { value: '3XL-TA' },
        { value: '52″–56″' },
        { value: '19″–19.5″' },
        { value: '37.5″' },
      ],
    ],
  ],
};

export const MensTallBottoms = {
  header: MensBottomsHeader,
  body: MensBottomsBody,
};

export const MensTallBelts = {
  header: MensBeltsHeader,
  body: MensBeltBody,
};

export const MensSizeComparison = {
  header: [
    [
      [
        { value: 'Height', rowspan: 2 },
        { value: 'Size', colspan: 7 },
      ],
      [
        { value: 'XS' },
        { value: 'S' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL' },
        { value: '3XL' },
      ],
    ],
  ],
  body: [
    [
      [
        { value: '5′6″ - under' },
        { value: 'XS-SH' },
        { value: 'S-SH' },
        { value: 'M-SH' },
        { value: 'L-SH' },
        { value: 'XL-SH' },
        { value: 'XXL-SH' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '5′7″' },
        { value: 'XS' },
        { value: 'S' },
        { value: 'M-SH' },
        { value: 'L-SH' },
        { value: 'XL-SH' },
        { value: 'XXL-SH' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '5′8″' },
        { value: 'XS' },
        { value: 'S' },
        { value: 'M' },
        { value: 'L-SH' },
        { value: 'XL-SH' },
        { value: 'XXL-SH' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '5′9″' },
        { value: 'XS' },
        { value: 'S' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL-SH' },
        { value: 'XXL-SH' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '5′10″' },
        { value: 'XS' },
        { value: 'S' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL-SH' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '5′11″' },
        { value: 'XS-TA' },
        { value: 'S' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL' },
        { value: '3XL-SH' },
      ],
    ],
    [
      [
        { value: '6′0″' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL' },
        { value: '3XL' },
      ],
    ],
    [
      [
        { value: '6′1″' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL' },
        { value: '3XL' },
      ],
    ],
    [
      [
        { value: '6′2″' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M-TA' },
        { value: 'L' },
        { value: 'XL' },
        { value: 'XXL' },
        { value: '3XL' },
      ],
    ],
    [
      [
        { value: '6′3″' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M-TA' },
        { value: 'L-TA' },
        { value: 'XL-TA' },
        { value: 'XXL' },
        { value: '3XL' },
      ],
    ],
    [
      [
        { value: '6′4″' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M-TA' },
        { value: 'L-TA' },
        { value: 'XL-TA' },
        { value: 'XXL-TA' },
        { value: '3XL' },
      ],
    ],
    [
      [
        { value: '6′5″ + taller' },
        { value: 'XS-TA' },
        { value: 'S-TA' },
        { value: 'M-TA' },
        { value: 'L-TA' },
        { value: 'XL-TA' },
        { value: 'XXL-TA' },
        { value: '3XL-TA' },
      ],
    ],
  ],
};

export const AllSizeGuideTables = {
  womens: {
    regular: {
      dressesAndTops: WomensRegularDressesAndTops,
      bottoms: WomensRegularBottoms,
    },
    plus: {
      dressesAndTops: WomensPlusDressesAndTops,
      bottoms: WomensPlusBottoms,
    },
    petite: {
      dressesAndTops: WomensPetiteDressesAndTops,
      bottoms: WomensPetiteBottoms,
    },
  },
  mens: {
    standard: {
      tops: MensStandardTops,
      bottoms: MensStandardBottoms,
      belts: MensStandardBelts,
    },
    short: {
      tops: MensShortTops,
      bottoms: MensShortBottoms,
      belts: MensShortBelts,
    },
    tall: {
      tops: MensTallTops,
      bottoms: MensTallBottoms,
      belts: MensTallBelts,
    },
    sizeComparison: {
      default: MensSizeComparison,
    },
  },
};
